import { request } from "../base";

export interface SearchRebuildStats {
	rebuilt: Record<
		string,
		{ documents: number; size: string }
	>;
	timestamp: string;
}

export interface SearchIndexStatus {
	indexes: Record<
		"pro" | "project" | "room" | "blog",
		{
			exists: boolean;
			sizeBytes: number | null;
			lastModified: string | null;
		}
	>;
}

export const adminSearchApi = {
	rebuildIndex(type?: string) {
		const params = type ? `?type=${type}` : "";
		return request<SearchRebuildStats>(
			`/api/admin/search/rebuild${params}`,
			{ method: "POST" },
		);
	},
	// #358: surfaces real R2 index state so the admin page can show a
	// meaningful status without forcing a rebuild first.
	getStatus() {
		return request<SearchIndexStatus>(`/api/admin/search/status`);
	},
};
